import { useEffect, useState } from 'react';
import { Config } from '../features/common/Common.types';

export function useHeap(config: Config | null) {
  const [heap, setHeap] = useState();

  useEffect(() => {
    if (config?.HEAP_API_KEY && config?.HEAP_API_URL && !heap) {
      const wnd = window as any;
      const heapFunc = function (e: any) {
        return function (...args: any[]) {
          wnd.heap.push([e].concat(args.slice()));
        };
      };
      const heapProps = [
        'addEventProperties',
        'addUserProperties',
        'clearEventProperties',
        'identify',
        'resetIdentity',
        'removeEventProperty',
        'setEventProperties',
        'track',
        'unsetEventProperty',
      ];

      if (!wnd.heap) {
        wnd.heap = [] as any;
        wnd.heap.appid = config.HEAP_API_KEY;
        wnd.heap.config = {};

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = config.HEAP_API_URL.replace('{0}', config.HEAP_API_KEY);
        script.addEventListener('load', () => {
          heapProps.forEach((p) => {
            wnd.heap[p] = heapFunc(p);
          });

          setHeap(wnd.heap);
        });

        document.head.append(script);
      }
    }
  }, []);

  return heap;
}
